import { ReactElement, useContext, useEffect, useState } from 'react'
import UserAction from '../../../context/action/UserAction'
import { UserContext } from '../../../context/UserContext'
import DevelopusInputText from '../../../../../common/ui/input/DevelopusInputText'
import DevelopusDatePicker from '../../../../../common/ui/input/DevelopusDatePicker'
import { t } from 'i18next'
import { dateFromDatePicker } from '../../../../../common/utils/date-utils'
import { CreateUserUI, emptyCreateUserUI } from '../../../model/CreateUserUI'
import DevelopusRadio from '../../../../../common/ui/input/DevelopusRadio'
import Language from '../../../../../domain/user/Language'
import DevelopusSelector from '../../../../../common/ui/input/DevelopusSelector'

const StudentCreateForm = (): ReactElement => {
  const context = useContext(UserContext)
  const action = new UserAction(context)
  const [student, setStudent] = useState<CreateUserUI>(emptyCreateUserUI())

  useEffect(() => {
    action.setCreateUser(student)
  }, [student])

  const languageOptions = [
    { value: Language.GREEK, label: t('language.greek') },
    { value: Language.ENGLISH, label: t('language.english') },
    { value: Language.RUSSIAN, label: t('language.russian') },
    { value: Language.ALBANIAN, label: t('language.albanian') },
  ]

  const firstNameLabel = t('users.info.firstName')
  const firstNamePlaceholder = t('users.info.firstName')

  const lastNameLabel = t('users.info.lastName')
  const lastNamePlaceholder = t('users.info.lastName')

  const emailLabel = t('users.info.email')
  const emailPlaceholder = t('users.info.email')

  const birthdayLabel = t('users.info.birthday')

  const fatherNameLabel = t('users.info.fatherName')
  const fatherNamePlaceholder = t('users.info.fatherName')

  const addressLabel = t('users.info.address')
  const addressPlaceholder = t('users.info.address')

  const languageLabel = t('users.info.language')
  const languagePlaceholder = t('users.info.language')

  const phoneNumberLabel = t('users.info.phoneNumber')
  const phoneNumberPlaceholder = t('users.info.phoneNumber')

  const mobileNumberLabel = t('users.info.mobileNumber')
  const mobileNumberPlaceholder = t('users.info.mobileNumber')

  const idNumberLabel = t('users.info.idNumber')
  const idNumberPlaceholder = t('users.info.idNumber')

  const ssrNumberLabel = t('users.info.ssrNumber')
  const ssrNumberPlaceholder = t('users.info.ssrNumber')

  const vatNumberLabel = t('users.info.vatNumber')
  const vatNumberPlaceholder = t('users.info.vatNumber')

  const visuallyImpairedLabel = t('users.info.visuallyImpaired')

  const soundLabel = t('users.info.sound')

  const firstNameHandler = (value: string) => {
    if (student !== undefined) {
      setStudent({ ...student, firstName: value })
    }
  }

  const lastNameHandler = (value: string) => {
    if (student !== undefined) {
      setStudent({ ...student, lastName: value })
    }
  }

  const emailHandler = (value: string) => {
    if (student !== undefined) {
      setStudent({ ...student, email: value })
    }
  }

  const birthdayHandler = (value: Date) => {
    if (student !== undefined) {
      setStudent({ ...student, birthday: dateFromDatePicker(value) })
    }
  }

  const fatherNameHandler = (value: string) => {
    if (student !== undefined) {
      setStudent({ ...student, fatherName: value })
    }
  }

  const addressHandler = (value: string) => {
    if (student !== undefined) {
      setStudent({ ...student, address: value })
    }
  }

  const languageHandler = (value: Language) => {
    if (student !== undefined) {
      setStudent({ ...student, language: value })
    }
  }

  const phoneNumberHandler = (value: string) => {
    if (student !== undefined) {
      setStudent({ ...student, phoneNumber: value })
    }
  }

  const mobileNumberHandler = (value: string) => {
    if (student !== undefined) {
      setStudent({ ...student, mobileNumber: value })
    }
  }

  const idNumberHandler = (value: string) => {
    if (student !== undefined) {
      setStudent({ ...student, idNumber: value })
    }
  }

  const ssrNumberHandler = (value: string) => {
    if (student !== undefined) {
      setStudent({ ...student, ssrNumber: value })
    }
  }

  const vatNumberHandler = (value: string) => {
    if (student !== undefined) {
      setStudent({ ...student, vatNumber: value })
    }
  }

  const visuallyImpairedHandler = (value: boolean) => {
    if (student !== undefined) {
      setStudent({ ...student, visuallyImpaired: value })
    }
  }

  const soundHandler = (value: boolean) => {
    if (student !== undefined) {
      setStudent({ ...student, sound: value })
    }
  }

  return (
    <>
      {student !== undefined && (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <div>
              <DevelopusInputText
                defaultValue={student.firstName}
                onChange={firstNameHandler}
                placeholder={firstNamePlaceholder}
                label={firstNameLabel}
              />
              <DevelopusInputText
                defaultValue={student.lastName}
                onChange={lastNameHandler}
                placeholder={lastNamePlaceholder}
                label={lastNameLabel}
              />
              <DevelopusInputText
                defaultValue={student.email}
                onChange={emailHandler}
                placeholder={emailPlaceholder}
                label={emailLabel}
              />
              <DevelopusDatePicker
                label={birthdayLabel}
                value={student.birthday}
                onChange={birthdayHandler}
              />
              <DevelopusInputText
                defaultValue={student.fatherName}
                onChange={fatherNameHandler}
                placeholder={fatherNamePlaceholder}
                label={fatherNameLabel}
              />
              <DevelopusInputText
                defaultValue={student.address}
                onChange={addressHandler}
                placeholder={addressPlaceholder}
                label={addressLabel}
              />
              <DevelopusSelector
                defaultValue={student.language}
                options={languageOptions}
                placeholder={languagePlaceholder}
                label={languageLabel}
                onChange={languageHandler}
              />
            </div>
            <div>
              <DevelopusInputText
                defaultValue={student.phoneNumber}
                onChange={phoneNumberHandler}
                placeholder={phoneNumberPlaceholder}
                label={phoneNumberLabel}
              />
              <DevelopusInputText
                defaultValue={student.mobileNumber}
                onChange={mobileNumberHandler}
                placeholder={mobileNumberPlaceholder}
                label={mobileNumberLabel}
              />
              <DevelopusInputText
                defaultValue={student.idNumber}
                onChange={idNumberHandler}
                placeholder={idNumberPlaceholder}
                label={idNumberLabel}
              />
              <DevelopusInputText
                defaultValue={student.ssrNumber}
                onChange={ssrNumberHandler}
                placeholder={ssrNumberPlaceholder}
                label={ssrNumberLabel}
              />
              <DevelopusInputText
                defaultValue={student.vatNumber}
                onChange={vatNumberHandler}
                placeholder={vatNumberPlaceholder}
                label={vatNumberLabel}
              />
              <DevelopusRadio
                checked={student.visuallyImpaired}
                onChange={visuallyImpairedHandler}
                labelPlacement="start"
                label={visuallyImpairedLabel}
              />
              <DevelopusRadio
                checked={student.sound}
                onChange={soundHandler}
                labelPlacement="start"
                label={soundLabel}
              />
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default StudentCreateForm
